import { createStore } from 'redux';
import { persistStore } from 'redux-persist';
import reducer from './reducer';

// Define RootState by inferring the state type from the reducer
export type RootState = ReturnType<typeof reducer>;

// Define AppDispatch type for dispatching actions
export type AppDispatch = typeof store.dispatch;

// Create store and persistor
const store = createStore(reducer);
const persistor = persistStore(store);

export { store, persistor };

// Optionally, keep your DefaultReduxState type for specific state shape
export type DefaultReduxState = {
    auth: any;
};
